import licenseReport from '../license-report.json';

type LicenseReportEntry = { name: string; installedVersion: string; licenseType: string; licensePeriod: string };

export const LicenseReport = {
    get: (): LicenseReportEntry[] => {
        return licenseReport;
    },
};
